/**
 * Affichage des stats en étoiles entières 1–5 (voiture et pilote).
 */

const STAR_FULL = '★';
const STAR_EMPTY = '☆';

function clampStatStars(v: number): number {
  return Math.max(1, Math.min(5, Math.round(v)));
}

/** Voiture ou pilote : value 1–5 → 1 à 5 étoiles pleines */
export function renderStarsCar(value: number): string {
  return renderStarsDriver(value);
}

/** Pilote : value 1–5 → 1 à 5 étoiles */
export function renderStarsDriver(value: number): string {
  const v = clampStatStars(value);
  let html = '<span class="star-rating star-rating--stat" aria-label="' + v + '/5">';
  for (let i = 0; i < v; i++) html += '<span class="star star-full">' + STAR_FULL + '</span>';
  for (let i = v; i < 5; i++) html += '<span class="star star-empty">' + STAR_EMPTY + '</span>';
  html += '</span>';
  return html;
}

function mountInteractiveStars(
  container: HTMLElement,
  value: number,
  onChange: (value: number) => void,
  cssMod: 'car' | 'driver'
): void {
  const v = clampStatStars(value);
  container.innerHTML = '';
  container.className = `star-rating star-rating--${cssMod} star-rating--interactive`;
  container.dataset.currentValue = String(v);
  container.setAttribute('aria-label', v + '/5');

  function getDisplayValue(): number {
    const hoverVal = container.dataset.hoverValue;
    if (hoverVal !== undefined && hoverVal !== '') return clampStatStars(Number(hoverVal));
    return clampStatStars(Number(container.dataset.currentValue ?? v));
  }

  function refreshVisual(): void {
    const cur = getDisplayValue();
    container.querySelectorAll('.star-btn').forEach((b, idx) => {
      (b as HTMLElement).classList.toggle('filled', idx + 1 <= cur);
    });
    container.setAttribute('aria-label', cur + '/5');
  }

  function setHover(value: number | null): void {
    if (value == null) delete container.dataset.hoverValue;
    else container.dataset.hoverValue = String(value);
    refreshVisual();
  }

  for (let i = 1; i <= 5; i++) {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'star-btn';
    btn.dataset.value = String(i);
    btn.setAttribute('aria-label', i + '/5');
    btn.innerHTML = STAR_FULL;
    btn.addEventListener('mouseenter', () => setHover(i));
    btn.addEventListener('click', () => {
      const val = clampStatStars(i);
      container.dataset.currentValue = String(val);
      setHover(null);
      refreshVisual();
      onChange(val);
    });
    container.appendChild(btn);
  }
  container.addEventListener('mouseleave', () => setHover(null));
  refreshVisual();
}

/** Stat voiture (1–5 entier). */
export function mountInteractiveStarsCar(
  container: HTMLElement,
  value: number,
  onChange: (value: number) => void
): void {
  mountInteractiveStars(container, value, onChange, 'car');
}

/** Stat pilote (1–5 entier). */
export function mountInteractiveStarsDriver(
  container: HTMLElement,
  value: number,
  onChange: (value: number) => void
): void {
  mountInteractiveStars(container, value, onChange, 'driver');
}
